module.exports = __webpack_public_path__ + "static/media/1020695.c4d8f602.png";